import api from '@/api/index.js'

const operator_journeys_count_report = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_OPERATOR_JOURNEYS_COUNT_REPORT_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_OPERATOR_JOURNEYS_COUNT_REPORT: (state, data) => {
      state.data = data
      state.loading = false
    },
    SET_OPERATOR_JOURNEYS_COUNT_REPORT_ERROR: (state, error) => {
      state.error = error
    }
  },

  actions: {
    LoadOperatorJourneysCountReport({commit}, query) {
      let reqQueryStr = `operator=${query.operatorId}&`;
      if (query.period.year) {
        reqQueryStr += `year=${query.period.year}&month=${query.period.month}`
      } else {
        reqQueryStr += `from=${query.period.from}&to=${query.period.to}`
      }

      commit('SET_OPERATOR_JOURNEYS_COUNT_REPORT_ERROR', null)
      commit('SET_OPERATOR_JOURNEYS_COUNT_REPORT_LOADING', true);
      return api.get('operator-reports/journeys-count?' + reqQueryStr)
        .then((response) => {
          commit('SET_OPERATOR_JOURNEYS_COUNT_REPORT', response)
        })
        .catch((error) => {
          commit('SET_OPERATOR_JOURNEYS_COUNT_REPORT_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_OPERATOR_JOURNEYS_COUNT_REPORT_LOADING', false);
        })
    },
  }
}

export default operator_journeys_count_report
